import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, mergeMap, Observable, throwError } from 'rxjs';
import { REQUESTS_BASE_URL } from 'src/environments/environment';
import { CourseViewModel } from '../shared/viewModels/course.viewModel';

@Injectable({
  providedIn: 'root'
})
export class CourseManagmentService {
  private courseData: CourseViewModel = {
    courseType: '',
    location: '',
    availablePlaces: null,
    instructor: '',
    courseDates: [],
    startTime: null,
    endTime: null,
  };
  private newCourseCreatedSubject = new BehaviorSubject<boolean>(false);
  private courseDeletedSubject = new BehaviorSubject<boolean>(false);
  constructor(
    private http: HttpClient,
  ) {
  }

  updateCourseData(data: any) {
    this.courseData = { ...data };
  }

  getCourseData() {
    return this.courseData;
  }

  resetCourseData() {
    this.courseData = {
      courseType: '',
      location: '',
      availablePlaces: null,
      instructor: '',
      courseDates: [],
      startTime: null,
      endTime: null,
    };
  }

  getAllEvents(dateRange: { startDateMonth: string; endDateMonth: string }) {
    const { startDateMonth, endDateMonth } = dateRange;
    return this.http.get<any[]>(
      `${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/courses?startDateMonth=${encodeURIComponent(startDateMonth)}&endDateMonth=${encodeURIComponent(endDateMonth)}`
    );
  }

  getCourseCreationImageByPath(pathName: string) {
    return this.http.get(`${REQUESTS_BASE_URL}/api/file-manager/client-api/v2/fileWithLink`, {
      responseType: 'blob',
      params: new HttpParams().set('link', pathName)
    });
  }

  createCourse() {
    let body = {
      clubId: this.courseData.courseType,
      localisation: this.courseData.location,
      courseInstructor: this.courseData.instructor,
      placeNumber: this.courseData.availablePlaces,
      courseDateList: this.courseData.courseDates,
      startTime: this.courseData.startTime,
      endTime: this.courseData.endTime
    }
    return this.http.post(
      `${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/courses`,
      body,
      {
        observe: 'response'
      }
    )
  }
  modifyCourse(courseId: string){
    let body = {  
      id: courseId,
      localisation: this.courseData.location,
      courseInstructor: this.courseData.instructor,
      placeNumber: this.courseData.availablePlaces,
      courseDateList: this.courseData.courseDates,
      startTime: this.courseData.startTime,
      endTime: this.courseData.endTime
    }
    return this.http.put(
      `${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/courses`,
      body,
      {
        observe: 'response'
      }
    )
  }

  get newCourseCreated$(): Observable<boolean> {
    return this.newCourseCreatedSubject.asObservable();
  }

  set newCourseCreated(value: boolean) {
    this.newCourseCreatedSubject.next(value);
  }

  get courseDeleted$(): Observable<boolean> {
    return this.courseDeletedSubject.asObservable();
  }

  set courseDeleted(value: boolean) {
    this.courseDeletedSubject.next(value);
  }

  getCourseById(courseId: string) {
    return this.http.get(`${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/course`, {
      params: { courseId: courseId }
    });
  }

  getParticipantListByCourseById(courseId: string) {
    return this.http.get(`${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/course/participant`, {
      params: { courseId: courseId }
    });
  }

  deleteCourse(courseId:string){
    return this.http.delete<any>(`${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/course/${courseId}`)
  }
  
}